module.exports = __webpack_public_path__ + "img/Address.24d79b4a.png";